// Cómo se nombra una variante cuando hay que mostrarla fuera de su card.
//
// La usan el menú de "mover esta foto a…" de la ficha y el panel de detalle de
// la tabla. Vive acá y no en una de las dos porque el nombre tiene que ser el
// MISMO en las dos: si en un lado dice "Rojo / M" y en el otro "Variante 2", el
// usuario no puede saber que son la misma.
import type { VarianteDeLanzamiento } from "./lanzamientosApi";

/**
 * Los valores de sus atributos separados por barra, o su número si todavía no
 * cargó ninguno.
 *
 * El número sale de la POSICIÓN en la lista, no de un contador propio: es lo que
 * el usuario está viendo en pantalla, y una variante recién agregada tiene que
 * llamarse igual acá que en el lugar donde la creó.
 */
export function etiquetaDeVariante(v: VarianteDeLanzamiento, i: number): string {
  const valores = v.valores.map((x) => (x ?? "").trim()).filter((x) => x !== "");
  return valores.join(" / ") || `Variante ${i + 1}`;
}
